<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>
      <hb-back-button fallback="orders"/>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $tc('valinta.title', 1) }} - {{ valinta.otsikko }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>
    <v-row v-if="!loading && !hasEditPermission">
      <v-col class="mt-5" cols="auto">
        <h3>{{ $t('vastuualue.no_rights') }}</h3>
      </v-col>
    </v-row>
    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading && hasEditPermission">
        <v-col class="mt-2" cols="12" lg="6" md="10" offset-lg="0" offset-md="1">
          <v-row>
            <v-col cols="12">
              <v-form ref="form">
                <v-card color="#191919" outlined>
                  <v-card-title primary-title>

                    {{ $tc('valinta.title', 1) }}
                    <v-spacer></v-spacer>
                    <v-menu
                        v-if="valinta.id"
                        bottom
                        left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-icon>mdi mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item color="error" link @click="deleteValinta">
                          <v-list-item-subtitle>
                            <v-icon>mdi mdi-trash-can-outline</v-icon>
                            {{ $t('delete') }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-title>
                  <v-divider/>
                  <v-card-text>


                    <v-row>
                      <v-col class="mt-2" cols="12">
                        <v-text-field v-model.number="valinta.vuosi"
                                      :disabled="(!!valinta.id && !!valinta.vuosi) || saving || !hasEditPermission"
                                      :label="$t('valinta.vuosi')"
                                      :rules="[$rules.required]"
                                      class="required"
                                      type="number"
                                      validate-on-blur></v-text-field>
                        <v-autocomplete v-model="valinta.vastuualueId"
                                        :disabled="!!valinta.id || saving || !hasEditPermission"
                                        :item-text="(item) => item.nimi"
                                        :items="vastuualueet"
                                        :label="$tc('vastuualue.title',1)"
                                        :rules="[$rules.required]"
                                        class="required"
                                        item-value="id"
                                        validate-on-blur
                        ></v-autocomplete>
                        <v-autocomplete v-model="valinta.valintatyyppiId"
                                        :disabled="!valinta.vuosi || saving || !hasEditPermission"
                                        :item-text="(item) => item.nimi"
                                        :items="filteredValintatyypit"
                                        :label="$tc('valintatyyppi.title',1)"
                                        :rules="[$rules.required]"
                                        class="required"
                                        item-value="id"
                                        validate-on-blur
                        ></v-autocomplete>
                        <v-text-field v-model="valinta.otsikko"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.otsikko')"
                                      :rules="[$rules.required]"
                                      class="required"
                                      type="text"
                                      validate-on-blur></v-text-field>
                        <v-textarea v-model="valinta.kuvaus"
                                    :disabled="saving || !hasEditPermission"
                                    :label="$t('valinta.kuvaus')"
                                    type="text"
                                    validate-on-blur></v-textarea>
                        <v-text-field v-model="valinta.mittarinimi"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.mittarinimi')"
                                      type="text"
                                      validate-on-blur></v-text-field>
                        <v-text-field v-model="valinta.mittarilinkki"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.mittarilinkki')"
                                      type="text"
                                      validate-on-blur></v-text-field>

                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider/>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2" cols="12">
                        <v-text-field
                          :value="valinta.tavoiteQ1"
                          @input="onTavoiteInput('tavoiteQ1', $event)"
                          :disabled="saving || !hasEditPermission"
                          :label="$t('valinta.tavoiteQ1')"
                          type="number"
                          validate-on-blur
                        ></v-text-field>
                        <v-text-field
                          :value="valinta.tavoiteQ2"
                          @input="onTavoiteInput('tavoiteQ2', $event)"
                          :disabled="saving || !hasEditPermission"
                          :label="$t('valinta.tavoiteQ2')"
                          type="number"
                          validate-on-blur
                        ></v-text-field>
                        <v-text-field
                          :value="valinta.tavoiteQ3"
                          @input="onTavoiteInput('tavoiteQ3', $event)"
                          :disabled="saving || !hasEditPermission"
                          :label="$t('valinta.tavoiteQ3')"
                          type="number"
                          validate-on-blur
                        ></v-text-field>
                        <v-text-field
                          :value="valinta.tavoiteQ4"
                          @input="onTavoiteInput('tavoiteQ4', $event)"
                          :disabled="saving || !hasEditPermission"
                          :label="$t('valinta.tavoiteQ4')"
                          type="number"
                          validate-on-blur
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider/>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2" cols="12">

                        <v-text-field v-model.number="valinta.toteutumaQ1"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.toteutumaQ1')"
                                      type="number"
                                      validate-on-blur></v-text-field>
                        <v-text-field v-model.number="valinta.toteutumaQ2"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.toteutumaQ2')"
                                      type="number"
                                      validate-on-blur></v-text-field>
                        <v-text-field v-model.number="valinta.toteutumaQ3"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.toteutumaQ3')"
                                      type="number"
                                      validate-on-blur></v-text-field>
                        <v-text-field v-model.number="valinta.toteutumaQ4"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.toteutumaQ4')"
                                      type="number"
                                      validate-on-blur></v-text-field>

                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider/>
                  <v-card-text>
                    <v-row>
                      <v-col class="mt-2" cols="12">


                        <v-text-field v-model.number="valinta.jarjestysnumero"
                                      :disabled="saving || !hasEditPermission"
                                      :label="$t('valinta.jarjestysnumero')"
                                      class="mt-2"
                                      type="number"
                                      validate-on-blur></v-text-field>


                      </v-col>
                    </v-row>


                  </v-card-text>
                  <v-divider/>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn :disabled="!hasEditPermission" :loading="saving" color="primary" @click="save">{{
                        $t('save')
                      }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>

            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="valinta.id" class="mt-2" cols="12" lg="6" md="10" offset-lg="0" offset-md="1">
          <kommentit :valinta-id="valinta.id"/>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import api from '../apicollection';
import Kommentit from "@/components/Kommentit";

export default {
  name: 'ValintaEditView',
  components: {Kommentit,},
  data() {
    return {
      loading: true,
      valintatyypit: [],
      vastuualueet: [],
      valinta: {
        vuosi: null,
        vastuualueId: null,
        valintatyyppiId: null,
      },
      saving: false,
      showEditDialog: false,
      headers: [
        {
          text: this.$t('valinta.otsikko'),
          value: 'otsikko'
        },
        {
          text: this.$t('valinta.vuosi'),
          value: 'vuosi'
        },
        {
          text: this.$tc('vastuualue.title', 1),
          value: 'vastuualue'
        },
        {
          text: this.$tc('valintatyyppi.title', 1),
          value: 'valintatyyppi'
        },
        {
          text: this.$t('valinta.jarjestysnumero'),
          value: 'jarjestysnumero'
        },
        {
          text: '',
          value: '_'
        }
      ]
    };
  },
  computed: {
    filteredValintatyypit() {
      return this.valintatyypit.filter(v => v.vuosi == this.valinta.vuosi && v.vastuualueId == this.valinta.vastuualueId);
    },
    hasEditPermission() {
     return !this.valinta.id || (this.valinta.id && this.$hasEditPermission(this.valinta.vastuualueId))
    }
  },
  methods: {
    onTavoiteInput(field, value) {
      if (value === '' || value === null) {
        this.valinta[field] = null;
      } else {
        this.valinta[field] = Number(value);
      }
    },
    async deleteValinta() {
      const tehtavat = await api.getTehtavat(this.valinta.vastuualueId, this.valinta.id);
      if (tehtavat.length > 0) {
        this.$showErrorNotification(this.$t('errors.error_deleting_valinta_tehtava_existing'))
        return false;
      }
      if (!await this.$confirmDelete(this.$t('valinta.delete_valinta'))) return false;
      this.loading = true;
      try {
        await api.deleteValinta(this.valinta);
        this.$router.go(-1);
      } catch (e) {
        console.error(e);
        this.$showErrorNotification(this.$t('errors.error_deleting_valinta'))
      }
      this.loading = false;
    },
    async getValinta(id) {
      if (!id) return;
      const valinta = await api.getValinta(id);
      this.valinta = valinta;
    },
    async getValintatyypit() {
      const valintatyypit = await api.getValintatyypit();
      this.valintatyypit = valintatyypit;
    },
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueet();
      this.vastuualueet = vastuualueet;
    },
    async save() {
      const valinta = {...this.valinta};
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      try {
        if (valinta.id) {
          await api.updateValinta(valinta);
        } else {
          await api.createValinta(valinta);
        }
        this.$router.go(-1);
      } catch (e) {
        this.$showErrorNotification(this.$t('errors.error_saving_valinta'))
      } finally {
        this.saving = false;
      }
    },
    async reloadAll() {
      this.loading = true;
      await Promise.all([this.getValinta(this.$route.params.id), this.getValintatyypit(), this.getVastuualueet()])
      this.loading = false;
    }
  },
  watch: {
    ['$route.params.id']() {
      this.reloadAll();
    }
  },
  async mounted() {
    await this.reloadAll();

    if (!this.$route.params.id) {
      if (this.$route.query.vastuualueId) {
        this.valinta.vastuualueId = parseInt(this.$route.query.vastuualueId)
      }
      if (this.$route.query.vuosi) {
        this.valinta.vuosi = parseInt(this.$route.query.vuosi)
      }
      if (this.$route.query.valintatyyppiId) {
        this.valinta.valintatyyppiId = parseInt(this.$route.query.valintatyyppiId)
      }
    }
    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss" scoped></style>
